<div class="container-fluid">
    <iframe [src]="iframeUrl" style="box-sizing: border-box; border: 1px solid #444; position: absolute; top: 65px; left: 0; width: 100%; height: calc(100% - 65px); "></iframe>
</div>
